import { BackOfficeDtoConverter } from 'shared/services/backoffice-data-provider';

import { Campaign } from './models/campaign.model';

export class CampaignDtoConverter extends BackOfficeDtoConverter {
  convert(dto: any) {
    return Campaign.fromDto(dto) as any;
  }
}
